export enum formState {
    LoginView,
    RestoreView,
    NewAccount
}